/* ============================================================================
   SOLVA — BANDEAU COOKIES · Customer Privacy API de Shopify
   ----------------------------------------------------------------------------
   Charge l'API de consentement, n'affiche la bannière QUE si Shopify le demande
   (région + pas de choix enregistré), puis enregistre le consentement réel via
   setTrackingConsent (analytics + marketing + preferences + sale_of_data).
   ============================================================================ */
(function () {
  /* Mémoire LOCALE du choix. Indispensable : si setTrackingConsent échoue (API de
     consentement non configurée dans l'admin), Shopify n'enregistre rien et
     shouldShowBanner() redevient vrai à CHAQUE page → la bannière revenait sans cesse.
     Cette clé ne pilote que l'AFFICHAGE ; le consentement légal reste porté par l'API. */
  var STORE_KEY = 'facil_cc';

  function remembered() {
    try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; }
  }
  function remember(value) {
    try { localStorage.setItem(STORE_KEY, value ? 'yes' : 'no'); } catch (e) {}
  }

  function bindAndShow(api) {
    var banner = document.querySelector('[data-facil-cookie]');
    if (!banner || !api) return;

    /* Choix déjà fait sur ce navigateur → on ne réaffiche jamais. */
    if (remembered()) { banner.parentNode && banner.parentNode.removeChild(banner); return; }

    var shouldShow = true;
    try {
      if (typeof api.shouldShowBanner === 'function') {
        shouldShow = api.shouldShowBanner();
      } else if (typeof api.currentVisitorConsent === 'function') {
        var c = api.currentVisitorConsent();
        shouldShow = !(c && (c.marketing === 'yes' || c.marketing === 'no'));
      }
    } catch (e) { shouldShow = true; }

    if (!shouldShow) { banner.parentNode && banner.parentNode.removeChild(banner); return; }

    banner.hidden = false;

    function decide(value) {
      /* On mémorise TOUJOURS le choix côté thème : la bannière ne doit pas revenir,
         même si l'enregistrement côté Shopify échoue. */
      remember(value);
      banner.hidden = true;
      try {
        api.setTrackingConsent(
          {
            analytics: value,
            marketing: value,
            preferences: value,
            sale_of_data: value ? 'enabled' : 'disabled'
          },
          function (result) {
            if (result && result.error) {
              console.warn(
                '[facil] Consentement NON enregistré par Shopify :', result.error,
                '\n→ Activer Paramètres → Confidentialité des clients → Bannière de cookies.'
              );
            }
          }
        );
      } catch (e) {
        console.warn(
          '[facil] API de consentement Shopify indisponible :', e,
          '\n→ Activer Paramètres → Confidentialité des clients → Bannière de cookies.'
        );
      }
    }

    var accept = banner.querySelector('[data-cc-accept]');
    var refuse = banner.querySelector('[data-cc-refuse]');
    if (accept) accept.addEventListener('click', function () { decide(true); });
    if (refuse) refuse.addEventListener('click', function () { decide(false); });
  }

  function boot() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      bindAndShow(window.Shopify.customerPrivacy);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (!error && window.Shopify && window.Shopify.customerPrivacy) {
            bindAndShow(window.Shopify.customerPrivacy);
          }
        }
      );
    }
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
